import React from "react";
import { cn } from "utils/helpers";
import {
	TableHeaderProps,
	TableHeadOrCellProps,
	TableItemProps,
	TableProps,
} from "./types";

export const Table: React.FC<TableProps> = ({
	children,
	className,
	containerClass,
	...props
}) => {
	return (
		<div className={cn("overflow-x-auto overflow-y-auto", containerClass)}>
			<table
				className={cn(
					"relative w-full table-auto overflow-scroll rounded bg-white",
					className
				)}
				{...props}
			>
				{children}
			</table>
		</div>
	);
};

export const TableHeader: React.FC<TableHeaderProps> = ({
	children,
	className,
	sticky = true,
	...props
}) => {
	return (
		<thead
			className={cn(
				"z-10 bg-white [&_tr]:border-b",
				sticky && "sticky top-0 drop-shadow-sm",
				className
			)}
			{...props}
		>
			{children}
		</thead>
	);
};

export const TableHead: React.FC<TableHeadOrCellProps> = ({
	children,
	className,
	firstCol = false,
	...props
}) => {
	return (
		<th
			className={cn(
				"h-11 px-6 text-left align-middle font-roboto font-medium text-tertiary-600 [&:has([role=checkbox])]:pr-0",
				firstCol &&
					"sticky left-0 top-0 z-40 whitespace-nowrap bg-white drop-shadow-sm",
				className
			)}
			{...props}
		>
			<div style={{ fontSize: "12px" }}>{children}</div>
		</th>
	);
};

export const TableBody: React.FC<TableItemProps> = ({
	children,
	className,
	...props
}) => {
	return (
		<tbody
			className={cn(
				"relative z-[1] overflow-auto [&_tr:last-child]:border-0",
				className
			)}
			{...props}
		>
			{children}
		</tbody>
	);
};

export const TableRow: React.FC<TableItemProps> = ({
	children,
	className,
	...props
}) => {
	return (
		<tr
			className={cn("border-b transition-colors", className)}
			{...props}
		>
			{children}
		</tr>
	);
};

export const TableCell: React.FC<TableHeadOrCellProps> = ({
	children,
	className,
	firstCol = false,
	...props
}) => {
	return (
		<td
			className={cn(
				"px-3 py-4 align-middle xl:px-6",
				firstCol && "left-0 whitespace-nowrap bg-white",
				className
			)}
			{...props}
		>
			{children}
		</td>
	);
};
